exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_container__33tvz{display:flex;flex-direction:column;text-align:center}.style_container__33tvz>*{margin:1.5rem 0 0}.style_content__1LOJa{display:flex;flex-direction:column;align-items:center;background:#fff;width:23.5rem;text-align:center;box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2),0 .125rem .125rem 0 rgba(0,0,0,.12),0 0 .125rem 0 rgba(0,0,0,.14)}.style_description__27bFu{padding:0 1.5rem 1.5rem;width:100%}.style_back__16GgO{padding-top:1.5rem}.style_logo__1S36P{background-color:#2f93e0;color:#fff;font-size:2rem;display:flex;flex-direction:row;width:100%;justify-content:center;align-items:center;padding:.5rem}", ""]);

// exports
exports.locals = {
	"container": "style_container__33tvz",
	"content": "style_content__1LOJa",
	"description": "style_description__27bFu",
	"back": "style_back__16GgO",
	"logo": "style_logo__1S36P"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/areas/authentication/SignOut/style.less
// module id = 1863
// module chunks = 8